import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderSideEnum } from '@modules/orders-module/enums/order-side.enum'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'
import { ButtonSize } from '@shared/components/ui-kit/button/core/types/button-size.type'
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'

@UseLocales({ ru, en })
@Component({
	selector: 'app-trade-side-toggle',
	templateUrl: './trade-side-toggle.component.html',
	styleUrl: './trade-side-toggle.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ButtonComponent, TranslatePipe],
})
export class TradeSideToggleComponent {
	protected readonly orderSideEnum: typeof OrderSideEnum = OrderSideEnum

	public side: InputSignal<OrderSideEnum> = input<OrderSideEnum>(this.orderSideEnum.BUY)
	public size: InputSignal<ButtonSize> = input<ButtonSize>('m')

	public sideChange: OutputEmitterRef<OrderSideEnum> = output<OrderSideEnum>()
}
